import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-26b5e9db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "negativeMargin" }
const _hoisted_2 = { class: "navbar mb-4" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mt-2 mb-4 w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_5 = { class: "stepsContainer" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1))
const _hoisted_14 = {
  class: "formContainer mb-4",
  id: "formContainerScrollable"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          type: "h1",
          class: "mb-0",
          localizedKey: "Product Carbon Footprint Calculator",
          text: "Product Carbon Footprint Calculator"
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["step firstStep", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 0}])
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "General Information",
            text: "General Information"
          }),
          _hoisted_6
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 1}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('/bag-calculator/components-weights/' + _ctx.$store.state.estimationIdentifier)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Components Weights",
            text: "Components Weights"
          }),
          _hoisted_7
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 2}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('/bag-calculator/components-materials/' + _ctx.$store.state.estimationIdentifier)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Components Material",
            text: "Components Material"
          }),
          _hoisted_8
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 3}]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('/bag-calculator/chemicals/' + _ctx.$store.state.estimationIdentifier)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Chemicals Used",
            text: "Chemicals Used"
          }),
          _hoisted_9
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 4}]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('/bag-calculator/accessories/' + _ctx.$store.state.estimationIdentifier)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Accessories Used",
            text: "Accessories Used"
          }),
          _hoisted_10
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 5}]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('/bag-calculator/processes-locations-and-transports/' + _ctx.$store.state.estimationIdentifier)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Process Locations And Transportation",
            text: "Process Locations And Transportation"
          }),
          _hoisted_11
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 6}]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo('/bag-calculator/packaging/' + _ctx.$store.state.estimationIdentifier)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Packaging",
            text: "Packaging"
          }),
          _hoisted_12
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {'pointer' : _ctx.$store.state.estimationIdentifier, 'active' : _ctx.activeStep == 7}]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateTo('/bag-calculator/summary/' + _ctx.$store.state.estimationIdentifier)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Summary",
            text: "Summary"
          }),
          _hoisted_13
        ], 2)
      ])
    ]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ])
      ]),
      _: 1
    })
  ]))
}